// Site configuration - these values are populated from environment variables
// This allows the same codebase to be used for multiple sites (PPL and PPE)

export const siteConfig = {
  name: process.env.REACT_APP_SITE_NAME || 'Premier Parking Enforcement',
  url: process.env.REACT_APP_SITE_URL || 'premierparkingenforcementltd.co.uk',
  phone: process.env.REACT_APP_PHONE_NUMBER || '',
  
  // Computed values
  get email() {
    return `info@${this.url}`;
  },
  
  get emailLink() {
    return `mailto:${this.email}`;
  },
  
  // Company details
  address: {
    line1: 'Office 3, Block 4, Mint Drive',
    city: 'Birmingham',
    postcode: 'B18 6EA',
    country: 'United Kingdom',
    get full() {
      return `${this.line1}, ${this.city}, ${this.postcode}, ${this.country}`;
    }
  },
  
  director: 'Walton Wilkins'
};

export default siteConfig;

